import { useCallback } from "react"
import { TextField, TextFieldProps, useTheme } from "@mui/material"

type MarkdownInputProps = {
  fullHeight?: boolean
} & TextFieldProps
export const MarkdownInput = ({
  fullHeight,
	...others
}: MarkdownInputProps) => {
  const theme = useTheme()
  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Tab') {
        e.preventDefault()
        
        const { value, selectionStart, selectionEnd } = e.target as unknown as {
          value: string,
          selectionStart: number,
          selectionEnd: number
        }
        const el: HTMLInputElement = e.target as HTMLInputElement
        el.value = value.substring(0, selectionStart) + '\t' + value.substring(selectionEnd)
        el.selectionStart = selectionStart + 1
        el.selectionEnd = selectionStart + 1
        //console.log(el, { value, selectionEnd, selectionStart })
      }
    },
    []
  )
	return (
		<TextField
			{...others}
			hiddenLabel
			fullWidth
			variant='outlined'
			size='small'
			multiline
      sx={{
        '& .MuiInputBase-root': {
          height: fullHeight ? '100%' : undefined,
          alignItems: fullHeight ? 'flex-start' : undefined
        },
        '& .MuiInputBase-input': {
          fontSize: '0.875rem',
          lineHeight: '1.2rem',
          fontFamily: 'Monospace',
          tabSize: 2,
          height: (fullHeight === true) ? '100% !important' : undefined,
          overflowY: (fullHeight === true) ? ('auto !important' as 'auto') : undefined
        },
        height: (fullHeight === true) ? '100%' : undefined, 
        background: theme.palette.background.default
      }}
			onKeyDown={onKeyDown}
		/>
	)
}